import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid"
import Button from '@mui/material/Button';

import { yellow } from '@mui/material/colors';
import { getDisplaySize } from "../../utils/Items";
import { Dialog, Typography } from "@mui/material";

// 商品削除ダイアログ
export default function ProductPageDeleteProductDialog({open, onCloseDialog, product, deleteAction}) {

    const nullProductData ={
      productName: "",
      productKana:"",
      productClassLName: "",
      productClassMName: "",
      productClassSName: "",
      taxName: "",
      taxRate: ""
    }
  
    const {productName, productKana, productClassLName, productClassMName, productClassSName, taxName, taxRate} = product ? product : nullProductData;
  

    const onClickDelete = (event) => {
      deleteAction();
      alert(
        "以下の商品を削除しました。\n"
        + `商品名: ${productName}\n`
        + `商品名カナ: ${productKana}\n`
        + `部門名	: ${productClassLName}\n`
        + `中分類名	: ${productClassMName}\n`
        + `小分類名	: ${productClassSName}\n`
        + `税種	: ${taxName + " " +taxRate*100}%`        	
      );
      onCloseDialog(event);
    }
  
    const onCloseCancel = (event) => {
      onCloseDialog(event);
    }
  
    return(
      <Dialog open={open} onClose={onCloseCancel}>
        <Box padding={2} minWidth={400}>
          <Typography fontSize={20} fontWeight={700}>削除</Typography>
          <Box marginTop={2} marginBottom={1}>
            <Typography>商品一覧から、以下の商品を削除します。</Typography>
            <Box backgroundColor={yellow[100]} marginY={1} padding={1}>
              <Typography fontSize={20}>商品名:&nbsp;{productName}</Typography>
              <Typography fontSize={20}>商品名カナ:&nbsp;{productKana}</Typography>
              <Typography fontSize={20}>部門名:&nbsp;{productClassLName}</Typography>
              <Typography fontSize={20}>中分類名:&nbsp;{productClassMName}</Typography>
              <Typography fontSize={20}>小分類名:&nbsp;{productClassSName}</Typography>
              <Typography fontSize={20}>税種:&nbsp;{taxName + " " + taxRate*100}%</Typography>
            </Box>
          </Box>
  
          <Grid container>
            <Grid item xs textAlign='center'>
              <Button
                variant="contained"
                color='error'
                onClick={onClickDelete}
              >
                削除
              </Button>
            </Grid>
            <Grid item xs textAlign='center'>
              <Button variant="outlined" onClick={onCloseCancel}>戻る</Button>
            </Grid>
          </Grid>
        </Box>
      </Dialog>
    )
  }
  